<template>
  <div>
    <div class="botm-bar-wrap" v-if="!isSearchPage">
      <!-- promo-offer-nudges -->
      <div v-if="appliedOfferPromo && welcomeOffers.length">
        <div
          class="promo-offer-bar"
          :class="[isOfferSelected ? 'promo-offer-bar-active' : '']"
        >
          <div class="d-flex align-items-center">
            <!-- <img
              :src="staticImgBaseUrl + '/images/global/percentStar.svg'"
              class="star-img"
            /> -->
            <div>
              <div class="fs-12 pl8 color-slaty-dark">
                {{ appliedOfferPromo }} coupon selected!
              </div>
            </div>
          </div>
          <div @click="triggerOfferDetailsModal">
            <i aria-hidden="true" class="hkfi-arrow-line fs-12 tr"></i>
          </div>
        </div>
      </div>
      <div
        class="bottom-nav-home border-top"
        :class="{ 'justify-content-around': cartQuantity <= 0 }"
      >
        <div
          class="flex-row justify-content-between"
          v-for="(item, index) in parsedResults"
          :key="index"
        >
          <div
            @click="handleIconClick(item.link_rewrite)"
            class="align-items-center"
            :class="[cartQuantity > 0 ? 'flex-column' : 'd-flex gap10']"
            v-if="item.title !== 'View Cart'"
          >
            <span class="bb-ico-holder">
              <img :src="item.icon" alt="icon image" class="icon-bottom-bar" />
              <span
                v-if="isShowCount(item.attributes) && offersList.length"
                class="circular-holder"
                >{{ offersList.length }}</span
              >
            </span>
            <p class="fs-11">
              {{ item.title }}
            </p>
          </div>
          <span
            class="nav-item"
            @click="handleCartClick($event)"
            v-else-if="cartQuantity > 0 && item.title === 'View Cart'"
          >
            <div
              class="btn btn-checkout btn-home-nav disp-col-inline secondary"
            >
              <span class="cart-total mr3">
                <span class="cart-total">
                  <transition name="slide-fade" mode="out-in">
                    <span class="count-holder" :key="cartQuantity">{{
                      cartQuantity
                    }}</span>
                  </transition>
                  <img :src="item.icon" alt="cart" class="cart-icon" />
                </span>
              </span>
              <div class="d-flex align-items-center pr4">
                <span class="bold ml4 mr8 fs-14">{{ item.title }}</span>
                <i aria-hidden="true" class="hkfi-arrow-line fs-10 bold"></i>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <!-- bottom bar for cart in search page -->
    <div
      class="bottom-nav-focused plr16"
      :class="{ active: cartQuantity > 0 }"
      v-if="isSearchPage && cartQuantity > 0"
    >
      <span class="nav-item" @click="handleCartClick($event)">
        <div
          v-if="cartQuantity >= 0"
          class="btn btn-checkout disp-col-inline secondary"
        >
          <span class="mr3">
            <transition name="slide-fade" mode="out-in">
              <span :key="cartQuantity">
                {{ this.cartQuantity }}
                {{ this.cartQuantity > 1 ? "items" : "item" }}</span
              >
            </transition>
            <i aria-hidden="true" class="jfi-cart fs-18"></i>
          </span>
          <div class="d-flex align-items-center pr4">
            <span class="bold ml4 mr8 fs-14">View Cart</span>
            <i aria-hidden="true" class="hkfi-arrow-line fs-10 bold"></i>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import {
  staticImgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_VIEWCART,
  EVENT_CLICK_BOTTOM_STICKY_BAR,
} from "../helpers/analyticsEvents";

export default {
  name: "BottomBarHome",
  components: {},
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      staticImgBaseUrl,
      selectedPromoIndex: -1,
      parsedResults: [],
      isFooter: false,
    };
  },
  mounted() {
    this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
    setTimeout(() => {
      this.isFooter = true;
    }, 1000);
  },
  methods: {
    isShowCount(attrs) {
      const attributesArray = JSON.parse(`[${attrs}]`);
      let showCountValue = null;
      attributesArray.forEach((attribute) => {
        if (attribute.key === "showCount") {
          showCountValue = attribute.value;
        }
      });
      if (showCountValue) {
        return showCountValue;
      }
    },
    handleCartClick() {
      EVENT_CLICK_VIEWCART();
      Utility.sendToCartScreen();
    },
    handleIconClick(linkRewrite) {
      if (linkRewrite === "/menu") {
        EVENT_CLICK_BOTTOM_STICKY_BAR({
          positionWithinSection: 1,
          subcategory: "Menu",
        });
        let url =
          projectBasePathWithFolder +
          "/menu/" +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
        url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
        window.location.href = url;
      } else if (linkRewrite === "/offers") {
        EVENT_CLICK_BOTTOM_STICKY_BAR({
          positionWithinSection: 2,
          subcategory: "Offers",
        });
        Utility.sendToOffersScreen();
      } else {
        EVENT_CLICK_BOTTOM_STICKY_BAR({
          positionWithinSection: 2,
          subcategory: linkRewrite,
        });
      }
    },
    hideCartTotal() {
      return true;
    },
    triggerOfferDetailsModal() {
      document.body.classList.add("body-stop-scroll-mobile");

      this.$store.commit(keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG, true);

      this.appliedOfferPromo &&
        this.$store.state.Offers.offersList?.map((i, index) => {
          if (i.couponCode == this.appliedOfferPromo) {
            this.selectedPromoIndex = index;
            this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
              campaignId: i.campaignId,
            });
          }
        });

      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
        this.selectedPromoIndex
      );

      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_FROM_BOTTOM_BAR,
        true
      );
    },
  },
  computed: {
    cartQuantity() {
      if (this.$store.getters[keyMapsGetter.CART_QUANTITY] === 0) {
        this.parsedResults = this.parsedResults.filter(
          (x) => x.title != "View Cart"
        );
      } else {
        this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
      }
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    isOfferSelected() {
      return LocalStorageFunc.getCouponCode()?.code !== undefined
        ? true
        : false;
    },
    isSearchPage() {
      return this.$store.state.ProductItems.showSearchModal;
    },
    isNotificationVisible() {
      return this.$store.state.Notification.notificationVisibilityStatus;
    },
    getNotificationPosition() {
      return this.$store.state.Notification.notificationPosition;
    },
    getPositionClass() {
      if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom-big"
      ) {
        return "move-up-inline-cart-big active";
      } else if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom"
      ) {
        return "move-up-inline-cart active";
      } else if (this.cartQuantity > 0) {
        return "active";
      }
      return "";
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    offersList() {
      return this.$store.state.Offers.offersList;
    },
  },
};
</script>
